import * as types from '@/store/mutation-types'
import { Repository } from '@/repository/repository'
import { stripPayload } from '@/schemas'
import { services } from '@/services'

const apiRepository = Repository.call('items')

const state = {
  show: false,
  items: [],
  supplierOrderCode: null
}

const getters = {
  show: state => state.show,
  allItems: state => state.items,
  showSupplierOrderCode: state => state.supplierOrderCode
}

const actions = {
  async launchModalWithItems ({ commit }, { id, supplierOrderCode }) {
    const items = await apiRepository.getItems(id)
    if (!items.level) return items

    const response = services.cleanResponseService(stripPayload(items.data, 'items'))
    const postman = {
      id,
      supplierOrderCode,
      messages: response
    }

    commit(types.LAUNCH_ITEMS_MODAL, postman)
  },
  flush ({ commit }) {
    commit(types.SET_FLUSH_ITEMS_MODAL)
  },
  enable ({ commit }) {
    commit(types.START_ITEMS_MODAL)
  },
  disable ({ commit }) {
    commit(types.STOP_ITEMS_MODAL)
  }
}

const mutations = {
  [types.LAUNCH_ITEMS_MODAL] (state, items) {
    state.show = true
    state.items = items.messages
    state.supplierOrderCode = items.supplierOrderCode
  },
  [types.SET_FLUSH_ITEMS_MODAL] (state) {
    state.items = []
  },
  [types.START_ITEMS_MODAL] (state) {
    state.show = true
  },
  [types.STOP_ITEMS_MODAL] (state) {
    state.show = false
    state.items = []
    state.supplierOrderCode = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/items.js